import { render, staticRenderFns } from "./EmployeeProjectsHistory.vue?vue&type=template&id=6e5d8464"
import script from "./EmployeeProjectsHistory.vue?vue&type=script&lang=js"
export * from "./EmployeeProjectsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports